<script lang="ts" setup>
// @ts-nocheck - Property 'index' does not exist on type '{ $: ComponentInternalInstance; $data: {}; $props: Partial<{}> & Omit<Readonly<ExtractPropTypes<__VLS_TypePropsToRuntimeProps<PagebuilderAccordionProps>>> & VNodeProps & AllowedComponentProps & ComponentCustomProps, never>; ... 10 more ...; $watch<T extends string | ((...args: any) => any)>(source: T, cb: T extends ...'.
export interface WidgetEmployeesProps {
    employees: Employee[]
    headingLevel?: string
}

const { $t } = useNuxtApp()

const props = withDefaults(defineProps<WidgetEmployeesProps>(), {
    headingLevel: 'h2',
})

const employeeGroups = computed<VNuxtLinkTo[]>((): VNuxtLinkTo[] => [
    {
        name: $t('Vedenie spoločnosti'),
        data: props.employees.filter((e) => e.type === 'directors'),
    },
    {
        name: $t('Dozorná rada'),
        data: props.employees.filter((e) => e.type === 'supervisors'),
    },
])
</script>

<template>
  <section>
    <Tracker :data="{ position: $t('Vedenie spoločnosti') }">
      <Heading
        level="h2"
        class="alfa text-center mb-4"
      >
        {{ $t('Vedenie spoločnosti') }}
      </Heading>
      <Tabs
        :links="employeeGroups"
        tabs-id="WidgetEmployees"
        type="secondary"
        class="text-center"
      >
        <template
          v-for="(group, index) in employeeGroups"
          :key="`employees-pane-${index}`"
          #[`tab-panel-${index}`]
        >
          <ScrollSection>
            <ScrollSectionItem
              v-for="(employee, employeeIndex) in group.data"
              :key="`employee-${employeeIndex}`"
              class="col-10 col-md-6 col-lg-4 pb-10 pb-md-3"
            >
              <WidgetEmployeesItem
                :employee="employee"
                :heading-level="props.headingLevel"
              />
            </ScrollSectionItem>
          </ScrollSection>
        </template>
      </Tabs>
    </Tracker>
  </section>
</template>
